import { render, staticRenderFns } from "./AdminCompletition.vue?vue&type=template&id=7f21e5a4&"
import script from "./AdminCompletition.vue?vue&type=script&lang=ts&"
export * from "./AdminCompletition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports